"use client";
import * as React from "react";
import TicketInfoItem from "./TicketInfoItem";
import Swal from "sweetalert2";
import api from "../../utils/api";
// import { useSelectedAmount } from "./Context/SelectedAmountContext";

interface RechargeCardProps {
  total: number;
  cardNumber?: string;
  rfidData: RFIDData | null;
}

interface RFIDData {
  bookingDate: string;
  cardAmount: number;
  customerMobileNumber: string;
  customerName: string;
  numberOdAdults: string;
  numberOfChildren: string;
  status: string | null;
  ticketBookingId: number;
  ticketNumber: string;
  ticketRFIdCardRef: string;
  ticketUniqueRFIdNo: string;
}

const RechargeTicketDetails: React.FC<RechargeCardProps> = ({ total, cardNumber, rfidData }) => {
  const [rechargeAmount, setRechargeAmount] = React.useState(0);
  const [cardtype, setCardType] = React.useState(0);

  // const { total } = useSelectedAmount();
  // setRechargeAmount(total);

  React.useEffect(() => {
    setRechargeAmount(total);
  }, [total]);

  const ticketInfo = [
    { label: "Ticket No.", value: "12345" },
    { label: "Customer Name", value: "xxxxxxxxxx" },
    { label: "Customer Number", value: "1234567890" },
    { label: "Total Members", value: "7" },
    { label: "NO. Of Adults", value: "4" },
    { label: "Kids", value: "3" },
    { label: "Card Assign", value: "xxxxxxxxxxxxxxx" },
    { label: "Select Card ID", value: "6754321890" },
    { label: "Balance", value: "1000", hasBorder: true },
  ];

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setRechargeAmount(Number(e.target.value) || 0);
  };

  const confirmpay = async () => {
    if(!cardNumber || cardNumber.toString().length !== 10) {
      Swal.fire('Error!', 'Please enter a valid RF ID Card number.', 'error');
      return;
    }
    if(rfidData === null || rfidData?.ticketRFIdCardRef === null || rfidData?.ticketRFIdCardRef === undefined || rfidData?.ticketRFIdCardRef === "") {
      Swal.fire('Error!', 'Please scan a valid RF ID Card.', 'error');
      return;
    }
    if(rechargeAmount <= 0 || isNaN(rechargeAmount)) {
      Swal.fire('Error!', 'Please enter a valid recharge amount.', 'error');
      return;
    }
    if(cardtype === 0) {
      Swal.fire('Error!', 'Please select a payment type.', 'error');
      return;
    }
    try {
      //   await api.delete(`/api/TicketBooking/DeleteTicketBooking?bookingId=${id}`);
      const result = await Swal.fire({
        title: 'Confirm Recharge',
        html: `
            <div style="text-align:left">
              <p>Do you want to recharge the card with <b>₹${rechargeAmount}</b>?</p>
              <p><b>Ticket No.:</b> ${rfidData?.ticketRFIdCardRef}</p>
              <p><b>Customer Number:</b> ${rfidData?.customerMobileNumber}</p>
              <p><b>Selected Card ID:</b> ${cardNumber}</p>
              <p><b>Current Balance:</b> ₹${rfidData?.cardAmount}</p>
              <p><b>Recharge Amount:</b> ₹${rechargeAmount}</p>
              <p><b>New Balance (after recharge):</b> ₹${Number(rechargeAmount)}</p>
            </div>
          `,
        icon: 'question',
        showCancelButton: true,
        confirmButtonText: 'Yes, Recharge',
        cancelButtonText: 'Cancel',
      });

      if (result.isConfirmed) {
        // Place recharge logic here
        try {
          const submittedData = {
            cardRechargeCalculationId: 0,
            cardRechargeAmount: Number(rechargeAmount),
            isLocked: true,
            ticketRFIdRef: rfidData?.ticketRFIdCardRef,  // rfidData?.ticketRFIdCardRef
            rfidCardNumber: cardNumber,
            cardType: cardtype,
            staffUserid: JSON.parse(localStorage.getItem('user')!).userId,
            counterid: JSON.parse(localStorage.getItem('user')!).counterid,
          };
          const response = await api.post('/api/CardRecharge/AddCardRecharge', submittedData, {
            headers: {
              'Content-Type': 'application/json',
            }
          });

          if (response.status === 200 || response.status === 201) {
            Swal.fire('Success!', 'Card has been recharged.', 'success');
          } else {
            Swal.fire({
              icon: 'warning',
              title: 'Unexpected Response',
              text: 'Please try again later.',
            });
          }
        } catch (error) {
          Swal.fire({
            icon: 'error',
            title: 'Recharge Failed',
            text: 'Something went wrong while RFID Card recharge.',
          });
        }
        
      }
    } catch (error) {
      Swal.fire('Error!', 'Failed to recharge the card.', 'error');
    }
  };

  return (
    <aside className="col-12 col-md-12">
      <div className="p-4 bg-white rounded-3 border border-warning shadow-sm">
        <h3 className="mb-4 text-center fs-4 fw-semibold text-dark">Ticket Details</h3>

        <div className="mx-auto text-black small mb-4" style={{ maxWidth: "220px" }}>
          <p>Ticket No. - {rfidData?.ticketNumber}</p>
          <p>Customer Name - {rfidData?.customerName}</p>
          <p>Customer Number - {rfidData?.customerMobileNumber}</p>
          <p>Total Members - {Number(rfidData?.numberOdAdults) + Number(rfidData?.numberOfChildren)}</p>
          <p>NO. Of Adults - {Number(rfidData?.numberOdAdults)}</p>
          <p>Kids - {Number(rfidData?.numberOfChildren)}</p>
          <p>Card Assign - xxxxxxxxxxxxxxxxx</p>
          <p>Select Card ID - {cardNumber}</p>
          <p>Balance - {rfidData?.cardAmount}</p>
        </div>

        <div className="mb-4">
          <h4 className="mb-3 text-center fs-5 fw-semibold text-dark">Calculations</h4>

          <div className="mb-3">
            <label htmlFor="rechargeAmount" className="form-label small text-muted">
              Card Recharge (INR) ₹
            </label>
            <input
              id="rechargeAmount"
              type="text"
              value={rechargeAmount}
              onChange={handleInputChange}
              className="form-control text-black bg-light border-secondary"
              readOnly={true}
            />
          </div>
          <div className="mb-3">
            <label htmlFor="paymentType" className="form-label small text-muted">
              Select Payment Type
            </label>
            <select
              id="paymentType"
              className="form-select text-black bg-light border-secondary"
              value={cardtype}
              onChange={e => setCardType(Number(e.target.value))}
            >
              <option value={0}>-- Select Payment Type --</option>
                <option value={1}>UPI</option>
                <option value={2}>Credit Card</option>
                <option value={3}>Debit Card</option>
                <option value={4}>Cash</option>
                <option value={5}>Wallet</option>
                <option value={6}>Google Pay</option>
                <option value={7}>PhonePe</option>
                <option value={8}>Paytm</option>
                <option value={9}>Other</option>
            </select>
          </div>
        </div>
        <button className="btn btn-primary w-100 fw-semibold" onClick={confirmpay}>Pay</button>
      </div>
    </aside>
  );
};

export default RechargeTicketDetails;
